import { Box, Typography, styled } from "@mui/material";

export const PanelContainer = styled(Box, {
  label: "BackRightPanelContainer",
})(() => ({
  width: 368,
  flexShrink: 0,
  height: 569,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  overflowY: "auto",
  backgroundColor: "rgba(145, 158, 171, 0.2)",
  backdropFilter: "blur(30px)",
  WebkitBackdropFilter: "blur(30px)",
  borderRadius: 16,
  padding: "20px 24px",
  "&::-webkit-scrollbar": { width: "6px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(145, 158, 171, 0.3)",
    borderRadius: "3px",
  },
}));

export const ItemName = styled(Typography, {
  label: "BackRightItemName",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 500,
  fontSize: "13px",
  lineHeight: "20px",
  color: "#ffffff",
}));
